export const Route = {
  Home: "/",
  Login: "/login",
  Signup: "/signup",
  Waitlist: "/waitlist",
  Learn: "/learn",
  Pricing: "/pricing",
  ContactSales: "/contact-sales",
  Checkout: "/checkout",
  CheckoutThankYou: "/thank-you",
  NotFound: "/*",
  AuthAction: "/auth/action",
  TermOfService: "/terms-of-service",
  PrivacyPolicy: "/privacy-policy",
  AboutUs: "/about-us",
  Profile: "/profile",
  ForgotPassword: "/forgot-password",
  Model: "/model/:modelId",
  ModelTab: "/model/:modelId/:modelTabId",
  Deal: "/deal/:dealId",
  DealTracker: "/deal-tracker",
  Models: "/models",
  Contacts: "/contacts",
  Contact: "/contact/:contactId",
} as const;

export type RouteType = (typeof Route)[keyof typeof Route];
